export const outlookConfig = {
  appId: process.env.REACT_APP_MICROSOFT_APP_ID,
  // redirectUri: process.env.REACT_APP_URL,
  redirectUri: window?.location?.origin,
  scopes: ['user.read', 'mailboxsettings.read', 'calendars.readwrite'],
};
